'use client';

// src/index.ts
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { trackElementSize } from "@zag-js/element-size";
import { useEffect, useLayoutEffect, useState } from "react";
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? useLayoutEffect : useEffect;
function trackMutation(el, cb) {
  var _a, _b;
  if (!el || !el.parentElement) return;
  var win = (_b = (_a = el.ownerDocument) == null ? void 0 : _a.defaultView) != null ? _b : window;
  var observer = new win.MutationObserver(function () {
    cb();
  });
  observer.observe(el.parentElement, {
    childList: true
  });
  return function () {
    observer.disconnect();
  };
}
function useSizes(_ref) {
  var getNodes = _ref.getNodes,
    _ref$observeMutation = _ref.observeMutation,
    observeMutation = _ref$observeMutation === void 0 ? true : _ref$observeMutation;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    sizes = _useState2[0],
    setSizes = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    count = _useState4[0],
    setCount = _useState4[1];
  useSafeLayoutEffect(function () {
    var elements = getNodes();
    var cleanups = elements.map(function (element, index) {
      return trackElementSize(element, function (size) {
        setSizes(function (sizes2) {
          return [].concat(_toConsumableArray(sizes2.slice(0, index)), [size], _toConsumableArray(sizes2.slice(index + 1)));
        });
      });
    });
    if (observeMutation) {
      var firstNode = elements[0];
      cleanups.push(trackMutation(firstNode, function () {
        setCount(function (count2) {
          return count2 + 1;
        });
      }));
    }
    return function () {
      cleanups.forEach(function (cleanup) {
        cleanup == null ? void 0 : cleanup();
      });
    };
  }, [count]);
  return sizes;
}
function isRef(ref) {
  return _typeof(ref) === "object" && ref !== null && "current" in ref;
}
function useSize(subject) {
  var _useSizes = useSizes({
      observeMutation: false,
      getNodes: function getNodes() {
        var node = isRef(subject) ? subject.current : subject;
        return [node];
      }
    }),
    _useSizes2 = _slicedToArray(_useSizes, 1),
    size = _useSizes2[0];
  return size;
}
export { useSize, useSizes };